/**
 * /login — Surface Layer (/01)
 *
 * The canonical global login route. It renders the same passkey-first sign-in
 * surface as `/sign-in` (retained as a working alias for existing links), so
 * the operator-verified passkey flow is unchanged. An already-authenticated
 * visit redirects to the protected dashboard.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@auth/auth-store';
import { SignInPage } from './sign-in';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (useAuthStore.getState().identity) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: SignInPage,
});
